import qs from 'qs';

export interface ScorecardTemplateScope {
  departmentIds?: unknown;
  officeIds?: unknown;
  employmentTypes?: unknown;
  /**
   * t_customise_work_types replacement for `employmentTypes`. Callers send one
   * or the other, never both — see `scopeWorkType` in useScorecardTemplates.
   */
  atsWorkTypeIds?: unknown;
}

const compact = (value: unknown): unknown[] =>
  Array.isArray(value)
    ? value.filter((v) => v !== undefined && v !== null && v !== '')
    : [];

/**
 * Query string for `ats_scorecards/list_templates`.
 *
 * Returns undefined when there is nothing to filter on, so the caller asks for
 * the unscoped list rather than sending empty arrays. The job-details slice
 * seeds its scope with empty arrays, which `Object.keys` checks read as
 * populated — that is how department-scoped scorecards went missing from the
 * picker (ENG-3790).
 */
export function buildScorecardTemplateParams(
  scope: ScorecardTemplateScope
): string | undefined {
  const params: Record<string, unknown> = {};
  const departmentIds = compact(scope.departmentIds);
  const officeIds = compact(scope.officeIds);
  const employmentTypes = compact(scope.employmentTypes);
  const atsWorkTypeIds = compact(scope.atsWorkTypeIds);

  if (departmentIds.length) params.department_ids = departmentIds;
  if (officeIds.length) params.office_ids = officeIds;
  if (employmentTypes.length) params.employment_types = employmentTypes;
  if (atsWorkTypeIds.length) params.ats_work_type_ids = atsWorkTypeIds;

  if (Object.keys(params).length === 0) return undefined;
  return qs.stringify(params, { arrayFormat: 'brackets' });
}
